import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children"];
import { LayoutTile } from './LayoutTile';
import styled from 'styled-components';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CardWrapper = styled(LayoutTile).withConfig({
  displayName: "LayoutCard__CardWrapper",
  componentId: "rwusg7-0"
})(["box-shadow:var(--layout-lib-shadow-card);"]);
export const LayoutCard = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({}, rest, {
    forwardedAs: as,
    ref: ref,
    children: children
  }));
});